const cleanSheetUrl = (url) => {
    //const sheetIdx = url.indexOf('sheets/');
    //const endIdx = sheetIdx + 7;
    //return url.substring(endIdx);

    return url.replace('sheets/','');
};

export default cleanSheetUrl;